import React from 'react';
import Navigation from "./app/Navigation";
import {AuthProvider} from "./utils/contexts/auth-context";


function App() {
    return (
        <AuthProvider>
            <Navigation/>
        </AuthProvider>
    );
}

export default App;
